/**
 * A function to determine whether to display a field in a collection based
 * on whether there is data in at least one of the specified fields in the
 * collection, and that the collection is an array that is not empty.
 * @param {array} collection - An array of objects to loop through.
 * @param {string} field - The name of the field to check in the collection.
 * @returns {boolean} - True if the field exists and is non-empty in at least one instance, else false.
 */
export default function displayField(collection, field) {
  // Ensure collection is a non-empty array.
  if (! Array.isArray(collection) || 0 === collection.length) {
    return false;
  }

  return collection.reduce((acc, item) => acc
    || 0 === item[field]
    || !! item[field], false);
}
